export enum OrderType {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  SIGNING = 'signing',
}
